import Pendencia from "@pages/Pendencia/Pendencia";

export default Pendencia;
